import React from 'react'
import styled from 'styled-components'
import { storyblokEditable, SbBlokData } from '@storyblok/react'

interface HeroModuleTagProps {
    blok: {
        showTag?: boolean
        tagText?: string
        tagColor?: string
        tagBgColor?: string
        tagFontSize?: string
    }
}

const Container = styled.div<{ tagBgColor: string }>`
    display: flex;
    width: fit-content;
    align-items: center;
    justify-content: center;
    padding: ${props => props.tagBgColor ? '0.25rem 0.5rem' : '0'};
    background-color: ${props => props.tagBgColor};
    margin-bottom: 1rem;
    border-radius: 8px;

`

const Tag = styled.div<{ tagColor: string, tagBgColor: string, tagFontSize?: string }>`
    font-size: ${props => props.tagFontSize || '18px'};
    font-weight: 600;
    color: ${props => props.tagColor};
`

const HeroModuleTag = ({ blok }: HeroModuleTagProps & { blok: SbBlokData }) => {
    return (
        <Container {...storyblokEditable(blok)} tagBgColor={blok.tagBgColor}>
            {blok?.showTag && (
                <Tag tagColor={blok.tagColor} tagBgColor={blok.tagBgColor} tagFontSize={blok.tagFontSize}>
                    {blok.tagText}
                </Tag>
            )}
        </Container>
    )
}

export default HeroModuleTag